import { IconArrowDown } from "@/assets/icons/geist/IconArrowDown";
import { Button } from "@/components/flexkit/Button";
import { cn } from "@/components/podkit/lib/cn";
import { haptic } from "@/utils/haptic";
import { type FC, useCallback } from "react";

export type ScrollToBottomButtonProps = {
    onClick: () => void;
    visible: boolean;
    className?: string;
    "data-tracking-id-none"?: boolean;
};

export const ScrollToBottomButton: FC<ScrollToBottomButtonProps> = ({ onClick, visible, className }) => {
    const handleClick = useCallback(() => {
        haptic("light");
        onClick();
    }, [onClick]);

    return (
        <div
            className={cn(
                "pointer-events-none absolute bottom-10 left-1/2 z-10 -translate-x-1/2 transition-all duration-200",
                visible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0",
                className,
            )}
            data-tracking-id-none
        >
            <Button
                variant="ghost"
                size="sm"
                onClick={handleClick}
                className="pointer-events-auto rounded-full border border-border-base bg-surface-pure p-2 shadow-md hover:bg-surface-02"
                LeadingIcon={IconArrowDown}
                aria-label="Scroll to bottom"
                data-tracking-id="scroll-to-bottom-conversation"
            />
        </div>
    );
};
